// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS103: Rewrite code to no longer use __guard__
 * DS202: Simplify dynamic range loops
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import $ from 'jquery';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import {Part} from 'biojs/Part';
import * as contextmenu from 'components/ContextMenu';
import * as selectioncontextmenu from 'components/SelectionContextMenu';
import * as context from 'Context';
import Annotation from 'molbio/annotations/backbone/Annotation';
import CutSite from 'molbio/enzymes/backbone/CutSite';
import {CircularLayout, LabelLayout, RingLayout} from 'molbio/maps/circular/CircularLayout';
import {Labelable} from 'molbio/maps/circular/CircularMapTypedefs';
import Display from 'molbio/maps/circular/Display';
import LabeledSegmentsRingView from 'molbio/maps/circular/LabeledSegmentsRingView';
import {RingComponentOptions} from 'molbio/maps/circular/RingComponent';
import * as ringview from 'molbio/maps/circular/RingView';
import getNucleotideAwareDisplayName from 'molbio/maps/getNucleotideAwareDisplayName';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import TranslationAsAnnotation from 'molbio/translations/backbone/TranslationAsAnnotation';

class LabelsView extends ringview.RingView<LabelLayout> {
  circularLayout!: CircularLayout;
  debouncedUpdate!: () => void;
  fastDebouncedUpdate!: () => void;
  fastUpdate!: () => void;
  features!: Array<Labelable>;
  modelToLabelGroup!: {[modelCid: string]: SVGGElement};
  modelToRerender!: {[modelCid: string]: (expand: boolean) => void};

  static initClass(): void {
    this.prototype.className = 'labels';
  }

  override initialize(options: Required<RingComponentOptions<LabelLayout>>): void {
    super.initialize(options);
    this.circularLayout = options.circularLayout;
    this.features = [];
    this.modelToLabelGroup = {};
    this.modelToRerender = {};

    // We are doing this deliberately because we are the worst. We are basically storing the 'normal',
    // un-debounced update on fastUpdate, then storing it again with two different debounce durations.
    // Then we overwrite update with debouncedUpdate so that superclass and other external calls to update
    // instead call debouncedUpdate. We must atone for this somehow.
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.fastUpdate = this.update;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.fastDebouncedUpdate = debounce(this.update, 0);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.debouncedUpdate = debounce(this.update, 500);
    this.update = function () {
      this.$el.hide();
      this.debouncedUpdate();
    };
  }

  override die(): void {
    super.die();
    this.stopListening();
  }

  featureColor(d: Labelable): string {
    switch (d.type()) {
      case 'cutsite':
        return d3.rgb(d.color()!).darker(0.5).formatHex();
      case 'annotation':
      case 'translation':
      case 'part':
      case 'primer':
        return 'black';
      default:
        return 'black';
    }
  }

  textDecoration(d: Labelable): string | null {
    switch (d.type()) {
      case 'annotation':
      case 'translation':
      case 'part':
        return 'underline';
      default:
        return null;
    }
  }

  override computeOuterRadius(innerRadius: number): number {
    return innerRadius;
  }

  override setInnerRadius(r: number, fastUpdate?: boolean): void {
    this.layout.set('innerRadius', r);
    this.updateRadius(); // always update.
    if (fastUpdate) {
      this.fastDebouncedUpdate();
    } else {
      this.update();
    }
  }

  override registerListeners(): void {
    super.registerListeners();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'change:width change:height', this.update);
    this.listenTo(
      this.model.get('sequence').get('cutsites'),
      'change:visible add remove change:position change:color',
      this.fastDebouncedUpdate
    );
    this.listenTo(this.model.get('sequence').annotations(), 'layerChange', this.fastDebouncedUpdate);
    this.listenTo(this.model.get('sequence').translations(), 'layerChange', this.fastDebouncedUpdate);
    this.listenTo(this.model.get('sequence').parts(), 'layerChange', this.fastDebouncedUpdate);
    this.listenTo(this.model.get('sequence').sequencePrimers(), 'layerChange', this.fastDebouncedUpdate);

    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.get('sequence').get('cutsites'), 'change:hover', this.handleHover);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.get('sequence').annotations(), 'change:hover', this.handleHover);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.get('sequence').sequencePrimers(), 'change:hover', this.handleHover);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.get('sequence').get('cutsites'), 'change:selected', this.handleSelect);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.get('sequence').annotations(), 'change:selected', this.handleSelect);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.get('sequence').sequencePrimers(), 'change:selected', this.handleSelect);

    this.listenTo(this.layout, 'change:cutSitesVisible', this.fastUpdate);
    return this.listenTo(this.layout, 'change:axisVisible', this.fastUpdate);
  }

  pieceContextHandler(e: MouseEvent, d: Labelable): void {
    const sequence = this.model.get('sequence');
    switch (d.type()) {
      case 'annotation':
        selectioncontextmenu.open(e, sequence, selectioncontextmenu.ANNOTATION_MENU, {
          annotation: d as Annotation,
          feature: d as Annotation,
        });
        break;
      case 'translation':
        selectioncontextmenu.open(e, sequence, selectioncontextmenu.getSelectionMenu(), {
          translation: (d as TranslationAsAnnotation).get('translationComponentModel'),
          feature: (d as TranslationAsAnnotation).get('translationComponentModel'),
        });
        break;
      case 'part':
        selectioncontextmenu.open(e, sequence, selectioncontextmenu.getSelectionMenu(), {
          part: d as Part,
          feature: d as Part,
        });
        break;
      case 'primer':
        selectioncontextmenu.open(e, sequence, selectioncontextmenu.PRIMER_MENU, {
          primer: d as SequencePrimer,
          feature: d as SequencePrimer,
        });
        break;
      case 'cutsite':
        selectioncontextmenu.open(e, sequence, selectioncontextmenu.CUTSITE_MENU, {cutsite: d as CutSite});
        break;
      default:
        break;
    }
  }

  clickAction(e: MouseEvent, d: Labelable): void {
    switch (d.type()) {
      case 'annotation':
      case 'primer':
      case 'cutsite':
        d.click(this.model.get('sequence'), e.shiftKey);
        break;
      default:
        this.model.get('sequence').get('selection').select(d);
        break;
    }
  }

  dblClickAction(e: MouseEvent, d: Labelable): void {
    switch (d.type()) {
      case 'annotation':
      case 'primer':
      case 'cutsite':
        d.dblClick(this.model.get('sequence'), e.shiftKey);
        break;
      default:
        this.model.get('sequence').get('selection').select(d);
        break;
    }
  }

  handleSelect(
    model: Labelable,
    /* 'value' here refers to whether or not the selectable is selected */
    value: boolean,
    options: {event: string}
  ): void {
    const oldId = model.uid();

    // If the model isn't in a labelGroup, then we haven't rendered it,
    // either, because it is off screen or because it was labelled directly.
    // In any case, don't do anything.
    // FIXME: This doesn't actually work. model is a Selectable, and cannot be used to index an object.
    // @ts-expect-error This should be using the model cid but isn't.
    // eslint-disable-next-line benchlint/no-in-operator
    if (!(model in this.modelToLabelGroup)) {
      return;
    }

    // And as a result all of this is unreachable!
    const oldLabel = d3
      .select(this.el)
      .selectAll('tspan')
      .filter(`[id='${this.labelId(model)}']`);
    const oldGroup = this.modelToLabelGroup[oldId];
    const oldRerender = this.modelToRerender[oldId];

    if (options == null || (context.get('mapId') !== this.model.cid && options.event !== 'reset')) {
      // @ts-expect-error void assignment
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      d3.select(oldGroup).each(oldRerender(false));
    } else {
      // @ts-expect-error TranslationAsAnnotation has a hover _method_ (hard coded to false) but not a hover
      // _attribute_
      oldLabel.classed('selected-label', model.selected() || model.get('hover'));
    }
  }

  handleHover(model: Labelable, value?: boolean): void {
    let labels: d3.Selection<d3.BaseType, unknown, d3.BaseType, unknown>;
    // @ts-expect-error Part does not currently have a hover attribute
    // FIXME: but it should
    if (!model.visible()) {
      return;
    }
    // @ts-expect-error TranslationAsAnnotation has a hover _method_ (hard coded to false) but not a hover
    // _attribute_
    const hover = model.get('hover');
    value = hover || model.selected();
    const id = model.uid();

    const group = this.modelToLabelGroup[id];

    // labels = d3.select(@el).selectAll('tspan').filter("[id='#{@labelId(model)}']")
    if (!hover) {
      labels = d3
        .select(this.el)
        .selectAll('tspan')
        .filter(`[id='${this.labelId(model)}']`);
      if (labels.node() != null) {
        __guard__(labels.on('mouseout'), (x: (e: Event, d: Labelable, changeHover: boolean) => void) =>
          x.call(labels.node(), new Event('mouseout'), model, false)
        );
        labels.classed('selected-label', value!);
      }
    }

    // Show/hide group on hover if we didn't initiate hover.
    if (context.get('mapId') !== this.model.cid) {
      const gr = d3.select(group);
      // @ts-expect-error TranslationAsAnnotation has a hover _method_ (hard coded to false) but not a hover
      // _attribute_
      if (model.get('hover')) {
        if (gr.node() != null) {
          __guard__(gr.on('mouseenter'), (x1: (group: SVGGElement) => void) => x1.call(group));
        }
      } else if (gr.node() != null) {
        __guard__(gr.on('mouseleave'), (x2: (group: SVGGElement) => void) => x2.call(group));
      }
    }

    // labels.classed('selected-label', value)
    if (hover) {
      labels = d3
        .select(this.el)
        .selectAll('tspan')
        .filter(`[id='${this.labelId(model)}']`);
      if (labels.node() != null) {
        __guard__(labels.on('mouseover'), (x3: (e: Event, d: Labelable, changeHover: boolean) => void) =>
          x3.call(labels.node(), new Event('mouseover'), model, false)
        );
        labels.classed('selected-label', value!);
      }
    }
  }

  labelId(model: Labelable): string {
    return `label-${model.uid()}`;
  }

  labelRadius(): number {
    return this.circularView.getDNAView().layout.get('outerRadius') + 40;
  }

  override basePairToAngle(basepair: number): number {
    let a = this.angle(basepair) % (2 * Math.PI);
    if (a < 0) {
      a += 2 * Math.PI;
    }
    return a;
  }

  getAngle(d: Labelable): number {
    switch (d.type()) {
      case 'cutsite':
        return this.basePairToAngle(d.start());
      default: {
        const s = d.start();
        const e = d.end();
        const sa = this.basePairToAngle(s);
        let se = this.basePairToAngle(e);
        if (sa > se) {
          se += 2 * Math.PI;
        }
        return ((sa + se) / 2) % (2 * Math.PI);
      }
    }
  }

  override redraw(): void {
    this.$el.show();

    this.layout.set('outerRadius', this.layout.get('innerRadius'));
    const length = this.model.get('sequence').length();

    // oxlint-disable-next-line no-this-alias
    const ref = this;

    const leftBP = this.model.get('leftBP');
    const rightBP = this.model.get('rightBP');

    const cutsites =
      this.layout.get('cutSitesVisible') && !this.model.get('sequence').isReallyBig()
        ? this.model
            .get('sequence')
            .get('cutsites')
            .filter((cut) => {
              const pos = cut.get('position');
              return leftBP < rightBP ? leftBP <= pos && pos < rightBP : leftBP <= pos || pos < rightBP;
            })
        : [];

    const annotations = this.layout.get('annotationsVisible')
      ? // eslint-disable-next-line no-restricted-syntax
        _.filter(
          // @ts-expect-error renderedData is on SegmentsRingView; circularView.views is not typed narrowly enough
          this.circularView.views.annotationsView.renderedData,
          (d: LabeledSegmentsRingView<RingLayout, Annotation>) => !d.get('hasCircularLabel')
        )
      : [];

    const translations = this.layout.get('translationsVisible')
      ? // eslint-disable-next-line no-restricted-syntax
        _.filter(
          // @ts-expect-error renderedData is on SegmentsRingView; circularView.views is not typed narrowly enough
          this.circularView.views.translationsView.renderedData,
          (d: LabeledSegmentsRingView<RingLayout, TranslationAsAnnotation>) => !d.get('hasCircularLabel')
        )
      : [];

    const partAnnotations = this.layout.get('partAnnotationsVisible')
      ? // @ts-expect-error renderedData is on SegmentsRingView; circularView.views is not typed narrowly enough
        (this.circularView.views.partAnnotationsView.renderedData ?? []).filter(
          (d: LabeledSegmentsRingView<RingLayout, Part>) => !d.get('hasCircularLabel')
        )
      : [];

    const primers = this.layout.get('primersVisible')
      ? // eslint-disable-next-line no-restricted-syntax
        _.filter(
          // @ts-expect-error renderedData is on SegmentsRingView; circularView.views is not typed narrowly enough
          this.circularView.views.primersView.renderedData,
          (d: LabeledSegmentsRingView<RingLayout, SequencePrimer>) => !d.get('hasCircularLabel')
        )
      : [];

    // @ts-expect-error cutsites.concat infers type as Array<CutSite>
    this.features = cutsites.concat(annotations, translations, partAnnotations, primers);

    const dnaLayout = this.circularView.getDNAView().layout;
    const innerR = dnaLayout.get('outerRadius');
    const outerR = dnaLayout.get('outerRadius') + 7;
    const labelR = this.labelRadius();
    const angleFn = (d: Labelable): number => this.getAngle(d);

    const type = this.layout.get('type');
    const {circularLayout} = this;

    // Divide up labels into buckets. Each bucket corresponds to a line of text around the plasmid.
    const bucket: {[index: number]: Array<Labelable>} = {};
    const targOffset = Math.ceil(labelR / type.height());

    const targLine = (angle: number): number =>
      // Maps a model to the y of the line on which it should be placed.
      // Negative y is top, bottom y is bottom.
      Math.floor((-Math.sin(-angle + Math.PI / 2) * labelR) / type.height());

    function bucketIndex(angle: number): number {
      // Map a model to the bucket index in which it should be placed.
      // The buckets are numbered from -targOffset to 3 * targOffset
      const base = targLine(angle);
      if (angle > Math.PI) {
        return 2 * targOffset - base;
      } else {
        return base;
      }
    }

    function lineFromBucket(i: number): number {
      // Reverse mapping from bucket index to y of the line.
      if (i < targOffset) {
        return i;
      } else {
        return 2 * targOffset - i;
      }
    }

    // Determine the extremes of our buckets.
    const leftAngle = this.basePairToAngle(leftBP);
    const rightAngle = this.basePairToAngle(rightBP);
    const leftBucketIdx = bucketIndex(leftAngle);
    let rightBucketIdx = bucketIndex(rightAngle);

    if (rightBucketIdx === leftBucketIdx) {
      rightBucketIdx--;
    }
    let end;
    let i;
    let asc;
    let asc1;
    let end1;

    // All buckets above the leftmost bucket.
    for (
      // eslint-disable-next-line benchlint/disallow-comma-operator
      i = leftBucketIdx, end = 3 * targOffset, asc = leftBucketIdx <= end;
      asc ? i <= end : i >= end;
      asc ? i++ : i--
    ) {
      bucket[i] = [];
    }

    // All buckets below the rightmost bucket.
    for (
      // eslint-disable-next-line benchlint/disallow-comma-operator
      i = -targOffset, end1 = rightBucketIdx, asc1 = -targOffset <= end1;
      asc1 ? i <= end1 : i >= end1;
      asc1 ? i++ : i--
    ) {
      bucket[i] = [];
    }

    // All buckets:
    // for i in [-targOffset..3 * targOffset]
    //  bucket[i] = []

    // These parameters define the curve at which labels are placed: 30 * (line/targOffset)^4
    const H = 30;
    const N = 4;
    const A = H / Math.pow(targOffset, N);

    const offsetter = (line: number): number => A * Math.pow(line, N);

    for (const d of this.features) {
      const target = bucketIndex(angleFn(d));
      // Only visible features are added to buckets.
      // eslint-disable-next-line benchlint/no-in-operator
      if (target in bucket) {
        bucket[target].push(d);
      }
    }

    function handleBucket(i: number): void {
      // If the next bucket is empty, leave one, and push the remaining labels into the next one.
      bucket[i] = _.sortBy(bucket[i], angleFn);
      const cbucket = bucket[i];

      // If not at the last bucket...
      if (i < 3 * targOffset) {
        const nbucket = bucket[i + 1];
        // If this bucket has 1+ stuff and the next bucket exists (isnt off screen) and is empty.
        if (cbucket.length > 1 && nbucket != null && nbucket.length === 0) {
          // Add the excess stuff into the next bucket.
          bucket[i + 1] = cbucket.splice(1, cbucket.length - 1);
        }
      }
      if (cbucket.length === 0) {
        delete bucket[i];
      }
    }

    for (const range of ['right', 'left']) {
      if (range === 'right') {
        let asc2;
        let end2;
        for (
          // eslint-disable-next-line benchlint/disallow-comma-operator
          i = -targOffset, end2 = rightBucketIdx, asc2 = -targOffset <= end2;
          asc2 ? i <= end2 : i >= end2;
          asc2 ? i++ : i--
        ) {
          handleBucket(i);
        }
      } else {
        let asc3;
        let end3;
        for (
          // eslint-disable-next-line benchlint/disallow-comma-operator
          i = leftBucketIdx, end3 = 3 * targOffset, asc3 = leftBucketIdx <= end3;
          asc3 ? i <= end3 : i >= end3;
          asc3 ? i++ : i--
        ) {
          handleBucket(i);
        }
      }
    }

    const data = _.chain(bucket)
      .pairs()
      // @ts-expect-error Underscore types are not properly overloaded for objects
      .map((d) => [parseInt(d[0], 10), d[1]])
      .sortBy((d) => d[0])
      .value();

    let labelG = d3.select(this.el).selectAll('.plasmid-label').data(data);

    labelG.exit().remove();
    const enter = labelG
      .enter()
      .append('svg:g')
      .classed('plasmid-label', true)
      .classed('label-component', true);

    enter.append('svg:line').classed('hover-label-line1', true);
    enter.append('svg:line').classed('hover-label-line2', true);
    enter.append('svg:line').classed('label-line1', true);
    enter.append('svg:line').classed('label-line2', true);

    const gr = enter.append('svg:g').classed('more-group', true).attr('visibility', 'hidden');
    gr.append('svg:rect').classed('more-group-bg', true).attr('width', 0).attr('height', 0);
    gr.append('svg:text')
      .classed('more-group-text', true)
      .attr('font-size', type.fontSize)
      .attr('letter-spacing', type.letterSpacing);

    enter
      .append('svg:text')
      .classed('text-label', true)
      .attr('font-size', type.fontSize)
      .attr('letter-spacing', type.letterSpacing);

    labelG = enter.merge(labelG);

    const mapstate = this.model;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const {featureColor} = this;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const {textDecoration} = this;
    this.modelToLabelGroup = {};
    this.modelToRerender = {};
    const {modelToLabelGroup} = this;
    const {modelToRerender} = this;

    function featureRadius(d: Labelable): number {
      switch (d.type()) {
        case 'annotation':
          return (
            circularLayout.CircularAnnotationsLayout.get('outerRadius') -
            // @ts-expect-error annularLayer is set on the model by SegmentsRingView
            circularLayout.CircularAnnotationsLayout.get('ringHeight') * (d.get('annularLayer') + 0.5)
          );
        case 'translation':
          return (
            circularLayout.CircularTranslationsLayout.get('outerRadius') -
            // @ts-expect-error annularLayer is set on the model by SegmentsRingView
            circularLayout.CircularTranslationsLayout.get('ringHeight') * (d.get('annularLayer') + 0.5)
          );
        case 'part':
          return (
            circularLayout.CircularPartAnnotationsLayout.get('outerRadius') -
            // @ts-expect-error annularLayer is set on the model by SegmentsRingView
            circularLayout.CircularPartAnnotationsLayout.get('ringHeight') * (d.get('annularLayer') + 0.5)
          );
        case 'primer':
          return (
            circularLayout.CircularPrimersLayout.get('innerRadius') +
            // @ts-expect-error annularLayer is set on the model by SegmentsRingView
            circularLayout.CircularPrimersLayout.get('ringHeight') * (d.get('annularLayer') + 0.5)
          );
        default:
          return innerR;
      }
    }

    const bindStopPropagation = (f: (e: MouseEvent, d: Labelable) => void, ref: this) =>
      function (e: MouseEvent, d: Labelable) {
        e.stopPropagation();
        return f.call(ref, e, d);
      };

    const labelEach = (expand: boolean): ((d: [number, Array<Labelable>], i: number) => void) =>
      function (d: [number, Array<Labelable>]): void {
        let labelWidth;
        // @ts-expect-error shadows outer this
        const labelText = d3.select(this).select('.text-label');
        // @ts-expect-error shadows outer this
        const hoverLabelLine1 = d3.select(this).select('.hover-label-line1').attr('stroke', 'none');
        // @ts-expect-error shadows outer this
        const hoverLabelLine2 = d3.select(this).select('.hover-label-line2').attr('stroke', 'none');
        // @ts-expect-error shadows outer this
        const labelLine1 = d3.select(this).select('.label-line1').attr('visibility', 'visible');
        // @ts-expect-error shadows outer this
        const labelLine2 = d3.select(this).select('.label-line2').attr('visibility', 'visible');
        // @ts-expect-error shadows outer this
        const moreGroup = d3.select(this).select('.more-group');
        const moreText = moreGroup.select('.more-group-text');
        const moreRect = moreGroup.select('.more-group-bg');
        let angle = angleFn(d[1][0]);

        const onRight = d[0] < targOffset;
        const targetLine = lineFromBucket(d[0]);
        const targetY = targetLine * type.height();
        const effectiveY = Math.min(labelR, Math.abs(targetY));
        const targetX =
          (Math.sqrt(labelR * labelR - effectiveY * effectiveY) + offsetter(targetLine)) * (onRight ? 1 : -1);
        const labelPt = {x: targetX, y: targetY};
        const outPt = Display.polar(outerR, angle);
        const onPt = Display.polar(innerR, angle);
        const r1 = Math.sqrt(
          labelPt.x * labelPt.x + (labelPt.y - type.height() / 4) * (labelPt.y - type.height() / 4)
        );
        const r2 = r1 - 5;
        const lineLabelPt = {x: (labelPt.x * r2) / r1, y: ((labelPt.y - type.height() / 4) * r2) / r1};
        const labelMinWidth = type.width(_.max(d[1].map((d) => getNucleotideAwareDisplayName(d).length)) + 1);

        function getLeftRight(): {x: number; width: number; firstWidth: number} {
          let width;
          let x;
          const maxX = ref.model.get('width')! / 2 - 20;
          const minWidth = Math.max(50, labelMinWidth);
          let firstWidth: number;
          if (onRight) {
            ({x} = labelPt);
            width = maxX - labelPt.x;
            firstWidth = width;
            if (width < minWidth) {
              x = maxX - minWidth;
              width = minWidth;
            }
          } else {
            x = -maxX;
            width = labelPt.x + maxX;
            firstWidth = width;
            if (width < minWidth) {
              width = minWidth;
            }
          }
          return {
            x,
            width,
            firstWidth,
          };
        }

        const sortedData = _.chain(d[1])
          .sortBy((d) => d.start())
          .sortBy((d) => {
            if (d.type() === 'cutsite' && (d as CutSite).get('enzyme').forceVisible()) {
              return -1;
            } else {
              return 1;
            }
          })
          .sortBy((d) => {
            if (d.selected()) {
              return -1;
            } else {
              return 1;
            }
          })
          .sortBy((d) => {
            switch (d.type()) {
              case 'annotation':
                return -5;
              case 'translation':
                return -4;
              case 'part':
                return -3;
              case 'primer':
                return -2;
              case 'cutsite':
                return -1;
              default:
                return 0;
            }
          })
          .value();

        let leftRight = getLeftRight();
        let width = onRight ? leftRight.x + leftRight.width - labelPt.x : labelPt.x - leftRight.x;

        let cutoff: number;
        let excess: number;
        let column = 0;

        function moreSize(cutoff: number): number {
          const more = sortedData.length - cutoff;
          if (more > 0) {
            return type.width(1 + String(more).length);
          } else {
            return 0;
          }
        }

        excess = -1;
        while (excess + 1 < sortedData.length) {
          labelWidth = type.width(getNucleotideAwareDisplayName(sortedData[++excess]).length + 1);
          column += labelWidth;
          if (column > width) {
            break;
          }
        }

        cutoff = excess;
        while (cutoff >= 0) {
          if (column + moreSize(cutoff + 1) < width) {
            break;
          }
          column -= type.width(getNucleotideAwareDisplayName(sortedData[cutoff]).length + 1);
          cutoff--;
        }

        cutoff += 1;
        for (const model of sortedData) {
          // @ts-expect-error shadows outer this
          modelToLabelGroup[model.uid()] = this;
          modelToRerender[model.uid()] = labelEach;
        }

        const visibleCuts = sortedData.slice(0, cutoff);
        const hiddenCuts = sortedData.slice(cutoff);

        if (window.snapshot && visibleCuts.length === 0) {
          // @ts-expect-error shadows outer this
          $(this).hide();
        }

        moreGroup.attr('visibility', expand && hiddenCuts.length > 0 ? 'visible' : 'hidden');
        labelText.select('.more-label').remove();

        let singleLabel = labelText.selectAll('.indiv-label').data(visibleCuts);
        singleLabel.exit().remove();
        const tspan = singleLabel
          .enter()
          .append('svg:tspan')
          .classed('indiv-label', true)
          .attr('font-size', type.fontSize)
          .attr('letter-spacing', type.letterSpacing);
        tspan.append('svg:tspan').classed('just-label', true);
        tspan.append('svg:tspan').classed('comma', true);
        singleLabel = singleLabel.merge(tspan);

        function mouseoutHandler(e: MouseEvent, d: Labelable, changeHover: boolean): void {
          if (changeHover == null) {
            changeHover = true;
          }
          hoverLabelLine1.attr('stroke', 'none');
          hoverLabelLine2.attr('stroke', 'none');
          labelLine1.attr('visibility', 'visible');
          labelLine2.attr('visibility', 'visible');
          if (changeHover) {
            // @ts-expect-error TranslationAsAnnotation has a hover _method_ (hard coded to false) but not a hover
            // _attribute_
            context.using({mapId: mapstate.cid}, this, () => d.set({hover: false}));
          }
        }

        function mouseoverHandler(e: MouseEvent, d: Labelable, changeHover: boolean): void {
          if (changeHover == null) {
            changeHover = true;
          }
          const start = d.start();
          end = d.end();
          if (end <= start) {
            end += length;
          }
          angle = angleFn(d);

          const hoverOutPt = Display.polar(outerR, angle);

          const r = featureRadius(d);
          const hoverInPt = Display.polar(r, angle);

          hoverLabelLine1
            .attr('x1', lineLabelPt.x)
            .attr('y1', lineLabelPt.y)
            .attr('x2', hoverOutPt.x)
            .attr('y2', hoverOutPt.y)
            .attr('stroke-width', 1.5)
            .attr('stroke', 'black');
          hoverLabelLine2
            .attr('x1', hoverOutPt.x)
            .attr('y1', hoverOutPt.y)
            .attr('x2', hoverInPt.x)
            .attr('y2', hoverInPt.y)
            .attr('stroke-width', 1.5)
            .attr('stroke', ' black');
          labelLine1.attr('visibility', 'hidden');
          labelLine2.attr('visibility', 'hidden');

          if (changeHover) {
            // @ts-expect-error TranslationAsAnnotation has a hover _method_ (hard coded to false) but not a hover
            // _attribute_
            context.using({mapId: mapstate.cid}, this, () => d.set({hover: true}));
          }
        }

        function lazyExpand(): void {
          let displayWidth;
          let displayX;
          leftRight = getLeftRight();
          const {x} = leftRight;
          ({width} = leftRight);

          moreText.attr('text-anchor', onRight ? 'start' : 'end');

          let hiddenLabel = moreText.selectAll('.indiv-label').data(hiddenCuts);
          hiddenLabel.exit().remove();
          const hiddenTspan = hiddenLabel
            .enter()
            .append('svg:tspan')
            .classed('indiv-label', true)
            .attr('font-size', type.fontSize)
            .attr('letter-spacing', type.letterSpacing);
          hiddenTspan.append('svg:tspan').classed('just-label', true);
          hiddenTspan.append('svg:tspan').classed('comma', true);
          hiddenLabel = hiddenLabel.merge(hiddenTspan);

          let rowCount = 2;
          let columnCount = 0;
          hiddenLabel
            .each((d, i, nodes) => {
              d3.select(nodes[i])
                .select('.comma')
                .text(i < hiddenCuts.length - 1 ? ',' : '');
              return d3
                .select(nodes[i])
                .select('.just-label')
                .text(getNucleotideAwareDisplayName(d))
                .attr('text-decoration', textDecoration);
            })
            // eslint-disable-next-line @typescript-eslint/unbound-method
            .attr('id', ref.labelId)
            .attr('fill', featureColor)
            // eslint-disable-next-line @typescript-eslint/unbound-method
            .on('mousedown', bindStopPropagation(ref.pieceClickHandler, ref))
            // eslint-disable-next-line @typescript-eslint/unbound-method
            .on('dblclick', bindStopPropagation(ref.pieceDblClickHandler, ref))
            // eslint-disable-next-line @typescript-eslint/unbound-method
            .on('contextmenu', bindStopPropagation(ref.pieceContextHandler, ref))
            // @ts-expect-error this signature works just fine actually
            .on('mouseover', mouseoverHandler)
            // @ts-expect-error this signature works just fine actually
            .on('mouseout', mouseoutHandler)
            .classed('selected-label', (d) => d.selected() || d.hover());

          hiddenLabel.each(function (
            d: Labelable,
            i: number
          ): d3.Selection<d3.BaseType, unknown, d3.BaseType, unknown> {
            labelWidth = type.width(getNucleotideAwareDisplayName(d).length + 1);

            if (columnCount + labelWidth < width || columnCount === 0) {
              columnCount += labelWidth;
              if (i === 0) {
                return d3
                  .select(this)
                  .attr('dy', null)
                  .attr('x', onRight ? x : x + width);
              } else {
                return d3.select(this).attr('dy', null).attr('x', null);
              }
            } else {
              columnCount = labelWidth;
              rowCount += 1;
              return d3
                .select(this)
                .attr('dy', type.height())
                .attr('x', onRight ? x : x + width);
            }
          });

          let y = labelPt.y - type.height();
          const height = rowCount * type.height();
          let textY = y + 2 * type.height();
          if (y + height > ref.model.get('height')! / 2) {
            y -= height - type.height();
            textY = y + type.height();
          }

          if (labelPt.x < x) {
            displayX = -ref.model.get('width')! / 2;
            displayWidth = width + (x - displayX) + 5;
          } else {
            displayX = x - 5;
            displayWidth = width + 10;
          }

          moreRect
            .attr('fill', 'white')
            .attr('fill-opacity', 1)
            .attr('stroke-width', 2)
            .attr('stroke', 'black')
            .attr('x', displayX)
            .attr('y', y - 5)
            .attr('width', displayWidth)
            .attr('height', height + 10)
            .on('mousedown', (e) => e.stopPropagation())
            .on('dblclick', (e) => e.stopPropagation());

          moreText.attr('x', x);
          moreText.attr('y', textY);
        }

        if (hiddenCuts.length > 0 && !window.snapshot) {
          const moreLabel = labelText.append('svg:tspan').classed('more-label', true);
          moreLabel.text(`+${hiddenCuts.length}`);

          // @ts-expect-error shadows outer this
          d3.select(this)
            .on('mouseenter', function () {
              $(this).find('~ .plasmid-label').insertBefore(this);
              lazyExpand();
              labelText.attr('x', onRight ? leftRight.x : leftRight.x + leftRight.width);
              return moreGroup.attr('visibility', 'visible');
            })
            .on('mouseleave', function (e: MouseEvent, _: Labelable) {
              // @ts-expect-error toElement is an old deprecated function on mouse(enter|leave|over|out)
              // events and we should probably stop using it
              if (__guard__(e != null ? e.toElement : undefined, (x) => x.className) === 'backdrop') {
                // Wait until the contextmenu closes to hide the group.
                ref.listenToOnce(contextmenu.view, 'close', () => {
                  moreGroup.attr('visibility', 'hidden');
                  labelText.attr('x', labelPt.x);
                  return d3.select(this).each(labelEach(false));
                });
                return;
              }
              moreGroup.attr('visibility', 'hidden');
              labelText.attr('x', labelPt.x);
              return d3.select(this).each(labelEach(false));
            });
        } else {
          // @ts-expect-error shadows outer this
          d3.select(this).on('mouseenter', null).on('mouseleave', null);
        }

        singleLabel
          .each((d, i, nodes) => {
            d3.select(nodes[i])
              .select('.comma')
              .text(i < visibleCuts.length - 1 || (hiddenCuts.length > 0 && !window.snapshot) ? ',' : '')
              .attr('dx', -2);
            return d3
              .select(nodes[i])
              .select('.just-label')
              .text(getNucleotideAwareDisplayName(d))
              .attr('text-decoration', textDecoration);
          })
          // eslint-disable-next-line @typescript-eslint/unbound-method
          .attr('id', ref.labelId)
          .attr('fill', featureColor)
          // eslint-disable-next-line @typescript-eslint/unbound-method
          .on('mousedown', bindStopPropagation(ref.pieceClickHandler, ref))
          // eslint-disable-next-line @typescript-eslint/unbound-method
          .on('dblclick', bindStopPropagation(ref.pieceDblClickHandler, ref))
          // eslint-disable-next-line @typescript-eslint/unbound-method
          .on('contextmenu', bindStopPropagation(ref.pieceContextHandler, ref))
          // @ts-expect-error this signature works just fine actually
          .on('mouseover', mouseoverHandler)
          // @ts-expect-error this signature works just fine actually
          .on('mouseout', mouseoutHandler)
          .classed('selected-label', (d) => d.selected());

        labelText
          .attr('text-anchor', () => {
            if (d[0] < targOffset) {
              return 'start';
            } else {
              return 'end';
            }
          })
          .attr('x', labelPt.x)
          .attr('y', labelPt.y);

        labelLine1
          .attr('x1', lineLabelPt.x)
          .attr('y1', lineLabelPt.y)
          .attr('x2', outPt.x)
          .attr('y2', outPt.y)
          .attr('stroke-width', 1);

        labelLine2
          .attr('x1', outPt.x)
          .attr('y1', outPt.y)
          .attr('x2', onPt.x)
          .attr('y2', onPt.y)
          .attr('stroke-width', 1);
        if (expand) {
          lazyExpand();
        } else {
          moreText.selectAll('.indiv-label').attr('id', null);
        }
      };
    labelG.each(labelEach(false));
  }
}
LabelsView.initClass();

export default LabelsView;

function __guard__<TValue, TFofValue>(
  value: TValue,
  transform: (val: TValue) => TFofValue
): TFofValue | undefined {
  return value != null ? transform(value) : undefined;
}
